<div class="container-fluid">
  <div fxFlexFill FxLayout="column" class="card">
    <div class="card-body">
      <h3 class="mobile-text-centered mgtp-small">Unauthorized</h3>
      <h5>{{message}}</h5>
    </div>
  </div>
</div>